<mat-card class="p-0">
	<mat-card-content>
		<div *ngIf="!isLoadingProjectsSearch && IS_EMPTY(projectSearchString)">
			<h2 class="p-1 py-0 mb-0 label-text-light">Recently Updated Projects</h2>
			<div class="p-1 py-0 label-text-light" fxLayout="row">
				Showing the most recently updated projects
			</div>
		</div>

		<div
			*ngIf="isLoadingProjectsSearch && utilService.isNullOrUndefined(projectsList)"
			class="m-t-1 m-b-1"
		>
			<app-default-progress-bar> </app-default-progress-bar>
		</div>

		<div
			*ngIf="!isLoadingProjectsSearch && !utilService.isNullOrUndefined(projectsList)"
			class="p-1"
		>
			<h2
				*ngIf="projectsList.length > 0 && IS_NOT_EMPTY(projectSearchString)"
				class="py-0 mb-0 label-text-light"
			>
				Matching Projects
			</h2>
			<h2 *ngIf="projectsList.length == 0" class="py-0 mb-0 label-text-light">
				No matching projects found for the search.
			</h2>

			<mat-card
				(click)="showProject(project.id)"
				*ngFor="let project of projectsList; let cIndex = index"
				class="m-t-1 cursor-pointer m-b-0"
			>
				<mat-card-content class="primary-text font-size-14">
					<div class="m-t-override" fxLayout="row">
						<div class="ellipsis" fxFlex="33" fxLayoutAlign="start center">
							<b>
								<span [innerHTML]="project.name | highlightText: projectSearchString"></span>
							</b>
						</div>
						<div class="ellipsis" fxFlex="40" fxFlexOffset="2" fxLayoutAlign="start center">
							<span [innerHTML]="project.laneName | highlightText: projectSearchString"></span>
						</div>
						<div class="ellipsis" fxFlex="23" fxFlexOffset="2" fxLayoutAlign="start center">
							Owner: {{ project.ownerName }}
						</div>
					</div>
					<div class="m-t-0-6" fxLayout="row">
						<div fxFlex="33" fxLayoutAlign="start center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(project.dueDate)">
								Due: {{ project.dueDate }}
							</span>
						</div>
						<div fxFlex="40" fxFlexOffset="2" fxLayoutAlign="start center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(project.projectedMargin)">
								Projected Margin: {{ project.projectedMargin }}
							</span>
						</div>
						<div fxFlex="23" fxFlexOffset="2" fxLayoutAlign="end center">
							<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(accountUsers) && accountUsers.length > 0">
								<app-user-popover
									(userChanged)="changeOwner($event, cIndex)"
									[isEnabled]="cargochief.USER_ID == project.userId"
									[placeholder]="
										IS_NULL_OR_UNDEFINED(project.assigneeId) && cargochief.USER_ID != project.userId
											? 'Unassigned'
											: 'Assign User'
									"
									[selectedUsers]="
										IS_NULL_OR_UNDEFINED(project.assigneeId) ? [] : [project.assigneeId]
									"
									[singleselect]="true"
									[usersList]="projectUsersListMap[project.id]"
								>
								</app-user-popover>
							</div>
						</div>
					</div>
					<div class="m-t-0-7" fxLayout="row">
						<div fxFlex fxLayoutAlign="center center">
							<div
								(click)="$event.stopPropagation()"
								*ngIf="IS_NULL_OR_UNDEFINED(project.carriersCount) || project.carriersCount == 0"
								class="carrier-search-dropdown-button-disabled"
								fxFlex="90"
								fxLayoutAlign="center center"
								fxLayoutAlign="center center"
							>
								No Carriers
							</div>
							<div
								(click)="showCarriers(project.id); $event.stopPropagation()"
								*ngIf="IS_NOT_NULL_OR_UNDEFINED(project.carriersCount) && project.carriersCount > 0"
								class="carrier-search-dropdown-button"
								fxFlex="90"
								fxLayoutAlign="center center"
								fxLayoutAlign="center center"
							>
								{{ project.carriersCount + ' Carrier' + (project.carriersCount > 1 ? 's' : '') }}
							</div>
						</div>
						<div fxFlex fxLayoutAlign="center center">
							<mat-spinner
								*ngIf="IS_NULL_OR_UNDEFINED(project.notesCount)"
								[diameter]="11"
								strokeWidth="1"
							></mat-spinner>
							<div
								(click)="$event.stopPropagation(); showNotes(project)"
								*ngIf="IS_NOT_NULL_OR_UNDEFINED(project.notesCount)"
								fxFlex="100"
								fxLayoutAlign="center center"
							>
								<div
									*ngIf="project.notesCount > 0"
									class="carrier-search-dropdown-button"
									fxFlex="90"
									fxLayoutAlign="center center"
								>
									{{ project.notesCount + ' Note' + (project.notesCount > 1 ? 's' : '') }}
									<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
								</div>
								<div
									*ngIf="project.notesCount == 0"
									class="carrier-search-dropdown-button"
									fxFlex="90"
									fxLayoutAlign="center center"
								>
									Add Notes
								</div>
							</div>
						</div>
						<div *ngIf="IS_TASKS_ENABLED" fxFlex fxLayoutAlign="center center">
							<div
								(click)="$event.stopPropagation()"
								class="carrier-search-dropdown-button"
								fxFlex="90"
								fxLayoutAlign="center center"
							>
								<app-tasks-icon
									(taskAddedEvent)="taskAdded($event)"
									(tasksUpdatedEvent)="tasksUpdated($event)"
									[isLoadingTasks]="isLoadingTasks"
									[project]="projectDTOList[cIndex]"
									[taskList]="getTasksForProject(project.id)"
								>
								</app-tasks-icon>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</mat-card-content>
</mat-card>
